/* global ga */
import Radium from 'radium';
import React from 'react';

import Button from './_Button';

const emailInputStyle = {
  width: 280,
  border: '1px solid #ddd',
  borderRadius: 5,
  padding: '0 16px',
  margin: '8px',
  height: 48,
  lineHeight: '48px',
  outline: 'none',
  ':focus': {
    border: '1px solid #5bbae9',
  },
};

@Radium
export default class MailingListSignupForm extends React.Component {
  handleSubmit = () => {
    ga('send', 'event', 'newsletter', 'signup');
  };

  render() {
    return (
      <form
        action={
          '//reindex.us10.list-manage.com/subscribe/post' +
          '?u=9b29b7af813c2dada1bfb8d55&amp;id=e0eb2d3a8a'
        }
        method="post" id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        target="_blank"
        onSubmit={this.handleSubmit}>
        <h5>Join the Beta</h5>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <p style={{ maxWidth: '70ex' }}>
            Request access our beta program to be among the first developers to
            build React apps with Reindex. Sign up now and we will email you
            more information.
          </p>
        </div>
        <input
          type="email"
          defaultValue=""
          name="EMAIL"
          placeholder="Your email address"
          style={emailInputStyle} />
        <div style={{ position: 'absolute', left: -5000 }}>
          <input
            type="text"
            name="b_9b29b7af813c2dada1bfb8d55_e0eb2d3a8a"
            tabIndex={-1}
            value="" />
        </div>
        <Button
          element="input"
          type="submit"
          value="Request an invite"
          name="subscribe" />
      </form>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./ui/_MailingListSignupForm.jsx
 **/